const status = ['Inadimplente', 'em dia'];
const cobrancaStatus = ['Vencida', 'Pendente', 'Paga'];

const statusStyles = [
  {
    color: "#971D1D",
    background: "#FFEFEF"
  },
  {
    color: "#1FA7AF",
    background: "#EEF6F6"
  }
];

const statusStylesCobranca = [
  {
    color: "#971D1D",
    background: "#FFEFEF"
  },
  {
    color: '#C5A605',
    backgroundColor: '#FCF6DC'
  },
  {
    color: "#1FA7AF",
    background: "#EEF6F6"
  }
];

const getStatus = (index) => {
  return {
    nome: status[index],
    style: statusStyles[index]
  }
}

const getStatusCobranca = (index) => {
  return {
    nome: cobrancaStatus[index],
    style: statusStylesCobranca[index]
  };
};

module.exports = {
  getStatus,
  getStatusCobranca
};
